import { render, staticRenderFns } from "./Inspection.vue?vue&type=template&id=f8407428&scoped=true"
import script from "./Inspection.vue?vue&type=script&lang=js"
export * from "./Inspection.vue?vue&type=script&lang=js"
import style0 from "./Inspection.vue?vue&type=style&index=0&id=f8407428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8407428",
  null
  
)

export default component.exports